// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.05em;
}
.progress__item{
    background: #fff;
    border-radius: 0.3125em;
    opacity: 0.5;
    width: 3.125em;
    margin: 0 0.15625em;
    height: max(2px,0.125em);
    transition: 0.3s width, 0.3s background;
}
.progress__item--active{
    opacity: 1;
}


.video{
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 12.125em;
    border-radius: 1.4375em;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.video::before{
    content: "";
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    transition: 0.3s opacity;
    background: linear-gradient(176.15deg, rgba(0, 0, 0, 0.45) 3.16%, rgba(0, 0, 0, 0) 90.28%);
    z-index: 1;
    height: 3.5625em;
    pointer-events: none;
    border-radius: 1.4375em 1.4375em 0 0;
}
.video__image{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    z-index: 0;
    border-radius: 1.4375em;
}
.video__playWrapper{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer; 
    z-index: 2;
}
.video__playWrapper2{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none; 
    justify-content: center;
    align-items: center;
    justify-content: center;
    display: flex;
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
    transition: 0.3s;
    z-index: 4;
}
.started2 .video__playWrapper2{
    opacity: 1;
    visibility: visible;
}
.video__playWrapper2 svg{
    width: 2.75em;
    height: auto;
    margin: 0.1875em;
    pointer-events: none;
}
.started2 .video__playWrapper2 svg{
    pointer-events: all;
}
.video__play{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 2.75em;
    height: auto;
    transition: 0.3s transform, 0.3s opacity;
    margin: -1.375em 0 0 -1.375em;
}
.started2 .video__play,
.started .video__play{
    opacity: 0; 
}
.started2 .video__playWrapper{
    visibility: hidden;
    pointer-events: none;
}
.video__muted{
    position: absolute;
    left: 1.4em;
    bottom: 1.3em;
    transition: 0.3s transform;
    width: 2em;
    height: auto;
    z-index: 5;
}
.started .video__muted{
    transform: translateY(4em);
}
.video__channel{
    position: absolute;
    left: 1em;
    top: 0.9em;
    display: flex;
    align-items: center;
    color: #fff;
    transition: 0.3s transform;
    text-shadow: 0 0 0.5em rgba(0,0,0,0.5);
    z-index: 5;
}
.started .video__channel{
    transform: translateY(-3em);
}
.started.video::before{
    opacity: 0;
}
.video__channelIcon{
    flex-shrink: 0;
    width: 1.3125em;
    margin-right: 0.3125em;
}
.video__channelName{
    font-size: 0.75em;
    line-height: 1.166;
    font-weight: 500;
}
.video__channelSubs{
    font-size: 0.5625em;
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.8);
}



.question{
    width: 100%;
    overflow: hidden;
    padding: 1.625em 0.96875em 5.5em;
    color: #000;
    position: relative;
}
.question__content{
    width: 100%;
    overflow: hidden;
    background: #fff;
    border-radius: 1.5em;
    height: 11em; 
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1.8em 0;
    position: relative;
}
.question__title{
    font-size: 0.875em;
    line-height: 1.214; 
    margin-bottom: 2.05em;
    transition: 0.3s transform, 0.3s margin;
}
.question__content.answered .question__title{
    margin-top: -3.85em;
    transform: translateY(-1em);
}
.question__title i{
    font-size: 1.214em;
    line-height: 1;
}
.question__emos{
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    transition: 0.3s transform;
}
.question__emo{
    width: 1.875em;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 3.125em;
    margin: 0 1em;
    transition: 0.3s;
}
.question__emo svg{
    transition: 0.3s width;
    width: 100%;
    height: auto;
}
.question__emoText{
    font-size: 0.75em;
    line-height: 1;
}
.question__content.answered .question__emos--1 .question__emo:not(.active){
    opacity: 0.3;
}
.question__emo.active{
    width: 2.5em;
    height: 3.5625em;
    margin-top: -0.25em; 
}
.question__emos--2{
    transform: translateY(5em);
    transition: 0.3s transform;
    position: absolute;
    left: 0;
    bottom: 1.4em;
}
.question__content:not(.big) .question__emos--2.active{
    transform: translateY(0);
}
.question__emos--2 .question__emo{
    margin: 0 1.5625em;
    height: 3em;
}
.question__text{ 
    background: linear-gradient(180deg, #E5E4FF 0%, rgba(229, 228, 255, 0) 54.57%), #D1CFFF;
    background-blend-mode: overlay, normal, normal;
    mix-blend-mode: normal;
    border-radius: 1.5em;
    height: 11.25em;
    margin-left: -0.125em;
    margin-right: 0.37em;
    transform: translateX(25em) rotate(3deg);
    transition: 0.3s transform;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0.3em 0.6em 0;
}
.question__text1{ 
    background: linear-gradient(180deg, #E5E4FF 0%, rgba(229, 228, 255, 0) 54.57%), #D1CFFF;
    background-blend-mode: overlay, normal, normal;
    mix-blend-mode: normal;
    border-radius: 1.5em;
    height: 11.25em; 
    transform: rotate(-3deg) translateX(-100vw);
    transition: 0.3s transform;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    top: 24.7em;
    left: 1.1em;
    width: 21.25em;
    padding: 0 0.6em;
}
.big~.question__text1{ 
    transform: rotate(-3deg);
}
.question__text.active{
    transform: rotate(3deg);
}
.question__textContent{
    font-size: 0.875em;
    line-height: 1.429;
} 
.question__textContent i{
    font-size: 1.22em;
    line-height: 1;
}
.big .question__emos--1{
    transform: translateX(-110%);
}
.question__big{
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: translateX(110%);
    transition: 0.3s transform;
}
.big .question__big{
    transform: translateY(0);
}
.question__bigSvg{
    margin-bottom: 0.7em;
}
.question__bigSvg svg{
    width: 7.125em;
    height: auto;
}
.question__bigText{
    line-height: 1;
    font-size: 0.768em;
}
.big+.question__text.active{
    transform: translateX(25em) rotate(3deg);
}
.question__next{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #8165FA;
    border-radius: 100%;
    position: absolute;
    border: none;
    width: 2.725em;
    height: 2.725em;
    padding: 0;
    top: 18.25em;
    right: 0.4em;
    transition: 0.3s transform;
    transform: translateX(5em);
}
.question__next svg{
    height: auto;
    width: 1.1875em;
}
.big~.question__next{
    transform: translateX(0);
}
.question__restart{
    position: absolute;
    left: 1.65em;
    bottom: 1.65em;
    display: flex;
    align-items: center;    
    justify-content: center;
    border: none;
    background: none;
    padding: 0;
    opacity: 0.5;
}
.question__restart svg{
    width: auto;
    height: 1.125em;
    clip-path: polygon(0 0, 75% 0, 75% 100%, 0% 100%);
}
.question__restart span{
    font-weight: 500;
    font-size: 0.875em;
    color: #fff;
    letter-spacing: 0.03em;
    margin-top: 0.05em;
}
.question2__title{
    width: 20.4375em;
    height: auto;
    display: block;
    margin: 1.3em auto 1.6em;
}
.question2__text{
    text-align: center;
    line-height: 1.2;
    padding: 0 1em;
    margin-bottom: -0.3em;
}
.question{
    padding-bottom: 3.5em;
}
@media(min-width: 100vh){ 
    .frame:not(.frame--results){
        font-size: 0.883em;
    }
    .question2__title{
        width: 33.8em;
        margin: 2.8em auto 1.6em;
    }
    .question2__text{
        font-size: 1.375em;
    }
    .main_emo{
        --koef: 1;
    }
    .main_emo--koef{
        --koef: 4;
    }
    .main_emoWrapper{
        transition: 0.8s margin;
    }
    .main_emoWrapper:nth-child(1){
        margin-left: calc(var(--koef) * 32.7em);
        top: 12.6em;
    }
    .main_emoWrapper:nth-child(2){
        margin-right:  calc(var(--koef) * 25.5em);
        top: 7.5em;
    }
    .main_emoWrapper:nth-child(3){
        top: 45.8em; 
        margin-right:  calc(var(--koef) * 37.9em);
    }
    .main_emoWrapper:nth-child(4){
        margin-left:  calc(var(--koef) * 32.6em);
        top: 60.3em;
    }
    .progress{
        margin-top: 4.3em; 

        margin: 4.1em 0 -2.3em;
    } 
    .progress__item{
        height: 0.34375em;
        width: 4.375em;
    }
    .video{
        width: 43em;
        height: 24.25em;
        border-radius: 2.8125em;
    }
    .video::before{
        background: linear-gradient(180.61deg, rgba(0, 0, 0, 0.54) 0.53%, rgba(0, 0, 0, 0) 99.47%);
        height: 5.9375em;
        border-radius: 2.8125em 2.8125em 0 0;
    }
    .video__image{
        border-radius: 2.8125em;
    }
    .video__play{
        width: 3.75em;
        margin: -1.875em 0 0 -1.875em;
    }
    .started .video__playWrapper2{
        visibility: visible;
        pointer-events: all;
    }
    .video__playWrapper2 svg{
        margin: 0.25em;
        width: 3.75em;
        transition: 0.3s transform;
        cursor: pointer;
    }
    .started .video__playWrapper2 svg{
        pointer-events: all;
    }
    .video__playWrapper2 svg:hover{
        transform: scale(1.1);
    }
    .started .video__playWrapper2:hover{
        opacity: 1;
    }
    .started .video__playWrapper{
        pointer-events: none;
    }
    .video__playWrapper:hover .video__play{
        transform: scale(1.1);
    }
    .video__muted{
        left: 2.3em;
        bottom: 2em;
        cursor: pointer;
        z-index: 33;
        transition: 0.3s transform, 0.3s opacity;
    } 
    .video__muted:hover{ 
        opacity: 0.7;
    }
    .started .video__muted{
        transform: translateY(5em);
    }
    .video:hover .video__muted{
        transform: translateY(0);
    }
    .video__channel{
        left: 2em;
        top: 1.9em;
    }
    .started .video__channel{
        transform: translateY(-5em);
    }
    .video__channelIcon{
        width: 1.9375em;
        margin-right: 0.625em;
    }
    .video__channelName{
        font-size: 1.125em;
        margin-bottom: 0.1em;
    }
    .video__channelSubs{
        font-size: 0.875em;
    }
    .question{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 4.625em;
        z-index: 2;
    }
    .question__content{
        width: 42.9375em;
        height: 18.75em;
        border-radius: 2.8125em;
        padding: 3.3em 0;
    }
    .question__title{
        font-size: 1.14em;
        margin-bottom: 4.15em;
    }
    .question__title br{
        display: none;
    } 
    .question__emo{
        width: 2.6875em;
        height: 4.8em;
        margin: 0 1.5625em;
        cursor: pointer;
        transition: 0.3s transform;
    }
    .question__emo svg{
        transition: 0.3s transform;
    }
    .question__emos--2.active .question__emo:hover svg,
    .question__content:not(.answered) .question__emos--1 .question__emo:hover{
        transform: scale(1.1);
    }
    .question__emos--2 .question__emo{
        height: 4.9em;
        margin: 0 1.9375em;
        margin: 0 2.1em;
    }
    .question__emos--2{
        transform: translateY(7em);
    }
    .question__content:not(.big) .question__emos--2.active{
        transform: translateY(-1.7em);
    }
    .question__emoText{
        font-size: 1em;
    }
    .question__emo.active{
        width: 3.125em;
        height: 5.2em;
        margin-top: -0.45em;
    }
    .question__content.answered .question__title{
        margin-top: -4.55em;
    }
    .question__text{
        margin: 0;
        position: absolute;
        top: 12.9em;
        left: 50%;
        margin: 0 0 0 19em;
        transform: rotate(4.37deg) translateX(50vw);
        width: 24.375em;
        height: 28.75em;
        border-radius: 2.8125em;
        padding: 0em 3.2em 0;
    }
    .question__text.active{
        transform: rotate(4.37deg);
    }
    .big+.question__text.active{
        transform: rotate(4.37deg) translateX(50vw);
    }
    .question__textContent{
        font-size: 1.125em;
        line-height: 1.3888;
    }
    .question__text1{
        margin: 0;
        position: absolute;
        top: 11.4em;
        left: 50%;
        margin: 0 0 0 16.4em;
        transform: rotate(-5.9deg) translateX(50vw);
        width: 24.375em;
        height: 28.75em;
        border-radius: 2.8125em;
        padding: 0em 3.2em 0;
    }
    .big~.question__text1 {
        transform: rotate(-5.9deg);
    }
    .question__next{
        right: inherit;
        left: 50%;
        top: 24.55em;
        margin-left: 40.2em;
        width: 4.3125em;
        height: 4.3125em;
        background: #fff;
        transform: translateX(50vw);
        transition: 0.3s background, 0.3s transform;
    }
    .question__next:hover{
        background: #9290FF;
    }
    .question__next svg{
        width: 2.0625em;
    }
    .question__next path{
        transition: 0.3s fill;
        fill: #9290FF;
    }
    .question__next:hover path{
        fill: #fff;
    }
    .big~.question__next {
        transform: translateX(0);
    }
    .question__bigText{
        font-size: 1em;
    }
    .question__bigSvg{
        margin-bottom: 2em;
    }
    .question__bigSvg svg{
        width: 11.68em;
    }
    .question__restart{
        left: 5.7em;
        bottom: 2.5em;
    }
    .question__restart:hover{
        opacity: 1;
    }
    .question__restart svg{
        clip-path: inherit;
        height: 1.5em;
        margin-right: 0.8em;
    }
    .question__restart span{
        font-size: 1.125em;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/Question/question.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,wBAAwB;IACxB,uCAAuC;AAC3C;AACA;IACI,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,wBAAwB;IACxB,0FAA0F;IAC1F,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,wCAAwC;IACxC,6BAA6B;AACjC;AACA;;IAEI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,UAAU;AACd;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,sCAAsC;IACtC,UAAU;AACd;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;;;AAIA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,uFAAuF;IACvF,8CAA8C;IAC9C,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,wCAAwC;IACxC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,uFAAuF;IACvF,8CAA8C;IAC9C,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,2CAA2C;IAC3C,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;IACf,iDAAiD;AACrD;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,wBAAwB;IAC5B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uCAAuC;QACvC,WAAW;IACf;IACA;QACI,yCAAyC;QACzC,UAAU;IACd;IACA;QACI,WAAW;QACX,yCAAyC;IAC7C;IACA;QACI,wCAAwC;QACxC,WAAW;IACf;IACA;QACI,iBAAiB;;QAEjB,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,cAAc;IAClB;IACA;QACI,WAAW;QACX,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,0FAA0F;QAC1F,gBAAgB;QAChB,oCAAoC;IACxC;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,6BAA6B;IACjC;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,aAAa;QACb,0BAA0B;QAC1B,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,UAAU;IACd;IACA;QACI,oBAAoB;IACxB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,WAAW;QACX,eAAe;QACf,WAAW;QACX,wCAAwC;IAC5C;IACA;QACI,YAAY;IAChB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,SAAS;QACT,UAAU;IACd;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,eAAe;QACf,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,qBAAqB;IACzB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,aAAa;QACb,kBAAkB;QAClB,eAAe;QACf,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;;QAEI,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;QACd,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,kBAAkB;QAClB,2CAA2C;QAC3C,eAAe;QACf,eAAe;QACf,uBAAuB;QACvB,oBAAoB;IACxB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,oBAAoB;QACpB,2CAA2C;QAC3C,eAAe;QACf,eAAe;QACf,uBAAuB;QACvB,oBAAoB;IACxB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,cAAc;QACd,SAAS;QACT,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,2BAA2B;QAC3B,2CAA2C;IAC/C;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,qBAAqB;QACrB,aAAa;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".progress{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2.05em;\n}\n.progress__item{\n    background: #fff;\n    border-radius: 0.3125em;\n    opacity: 0.5;\n    width: 3.125em;\n    margin: 0 0.15625em;\n    height: max(2px,0.125em);\n    transition: 0.3s width, 0.3s background;\n}\n.progress__item--active{\n    opacity: 1;\n}\n\n\n.video{\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    height: 12.125em;\n    border-radius: 1.4375em;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n.video::before{\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    transition: 0.3s opacity;\n    background: linear-gradient(176.15deg, rgba(0, 0, 0, 0.45) 3.16%, rgba(0, 0, 0, 0) 90.28%);\n    z-index: 1;\n    height: 3.5625em;\n    pointer-events: none;\n    border-radius: 1.4375em 1.4375em 0 0;\n}\n.video__image{\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    position: relative;\n    z-index: 0;\n    border-radius: 1.4375em;\n}\n.video__playWrapper{\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer; \n    z-index: 2;\n}\n.video__playWrapper2{\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none; \n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    visibility: hidden;\n    pointer-events: none;\n    opacity: 0;\n    transition: 0.3s;\n    z-index: 4;\n}\n.started2 .video__playWrapper2{\n    opacity: 1;\n    visibility: visible;\n}\n.video__playWrapper2 svg{\n    width: 2.75em;\n    height: auto;\n    margin: 0.1875em;\n    pointer-events: none;\n}\n.started2 .video__playWrapper2 svg{\n    pointer-events: all;\n}\n.video__play{\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 2.75em;\n    height: auto;\n    transition: 0.3s transform, 0.3s opacity;\n    margin: -1.375em 0 0 -1.375em;\n}\n.started2 .video__play,\n.started .video__play{\n    opacity: 0; \n}\n.started2 .video__playWrapper{\n    visibility: hidden;\n    pointer-events: none;\n}\n.video__muted{\n    position: absolute;\n    left: 1.4em;\n    bottom: 1.3em;\n    transition: 0.3s transform;\n    width: 2em;\n    height: auto;\n    z-index: 5;\n}\n.started .video__muted{\n    transform: translateY(4em);\n}\n.video__channel{\n    position: absolute;\n    left: 1em;\n    top: 0.9em;\n    display: flex;\n    align-items: center;\n    color: #fff;\n    transition: 0.3s transform;\n    text-shadow: 0 0 0.5em rgba(0,0,0,0.5);\n    z-index: 5;\n}\n.started .video__channel{\n    transform: translateY(-3em);\n}\n.started.video::before{\n    opacity: 0;\n}\n.video__channelIcon{\n    flex-shrink: 0;\n    width: 1.3125em;\n    margin-right: 0.3125em;\n}\n.video__channelName{\n    font-size: 0.75em;\n    line-height: 1.166;\n    font-weight: 500;\n}\n.video__channelSubs{\n    font-size: 0.5625em;\n    line-height: 1.2;\n    color: rgba(255, 255, 255, 0.8);\n}\n\n\n\n.question{\n    width: 100%;\n    overflow: hidden;\n    padding: 1.625em 0.96875em 5.5em;\n    color: #000;\n    position: relative;\n}\n.question__content{\n    width: 100%;\n    overflow: hidden;\n    background: #fff;\n    border-radius: 1.5em;\n    height: 11em; \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 1.8em 0;\n    position: relative;\n}\n.question__title{\n    font-size: 0.875em;\n    line-height: 1.214; \n    margin-bottom: 2.05em;\n    transition: 0.3s transform, 0.3s margin;\n}\n.question__content.answered .question__title{\n    margin-top: -3.85em;\n    transform: translateY(-1em);\n}\n.question__title i{\n    font-size: 1.214em;\n    line-height: 1;\n}\n.question__emos{\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    width: 100%;\n    transition: 0.3s transform;\n}\n.question__emo{\n    width: 1.875em;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    height: 3.125em;\n    margin: 0 1em;\n    transition: 0.3s;\n}\n.question__emo svg{\n    transition: 0.3s width;\n    width: 100%;\n    height: auto;\n}\n.question__emoText{\n    font-size: 0.75em;\n    line-height: 1;\n}\n.question__content.answered .question__emos--1 .question__emo:not(.active){\n    opacity: 0.3;\n}\n.question__emo.active{\n    width: 2.5em;\n    height: 3.5625em;\n    margin-top: -0.25em; \n}\n.question__emos--2{\n    transform: translateY(5em);\n    transition: 0.3s transform;\n    position: absolute;\n    left: 0;\n    bottom: 1.4em;\n}\n.question__content:not(.big) .question__emos--2.active{\n    transform: translateY(0);\n}\n.question__emos--2 .question__emo{\n    margin: 0 1.5625em;\n    height: 3em;\n}\n.question__text{ \n    background: linear-gradient(180deg, #E5E4FF 0%, rgba(229, 228, 255, 0) 54.57%), #D1CFFF;\n    background-blend-mode: overlay, normal, normal;\n    mix-blend-mode: normal;\n    border-radius: 1.5em;\n    height: 11.25em;\n    margin-left: -0.125em;\n    margin-right: 0.37em;\n    transform: translateX(25em) rotate(3deg);\n    transition: 0.3s transform;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 0.3em 0.6em 0;\n}\n.question__text1{ \n    background: linear-gradient(180deg, #E5E4FF 0%, rgba(229, 228, 255, 0) 54.57%), #D1CFFF;\n    background-blend-mode: overlay, normal, normal;\n    mix-blend-mode: normal;\n    border-radius: 1.5em;\n    height: 11.25em; \n    transform: rotate(-3deg) translateX(-100vw);\n    transition: 0.3s transform;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    position: absolute;\n    top: 24.7em;\n    left: 1.1em;\n    width: 21.25em;\n    padding: 0 0.6em;\n}\n.big~.question__text1{ \n    transform: rotate(-3deg);\n}\n.question__text.active{\n    transform: rotate(3deg);\n}\n.question__textContent{\n    font-size: 0.875em;\n    line-height: 1.429;\n} \n.question__textContent i{\n    font-size: 1.22em;\n    line-height: 1;\n}\n.big .question__emos--1{\n    transform: translateX(-110%);\n}\n.question__big{\n    pointer-events: none;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    transform: translateX(110%);\n    transition: 0.3s transform;\n}\n.big .question__big{\n    transform: translateY(0);\n}\n.question__bigSvg{\n    margin-bottom: 0.7em;\n}\n.question__bigSvg svg{\n    width: 7.125em;\n    height: auto;\n}\n.question__bigText{\n    line-height: 1;\n    font-size: 0.768em;\n}\n.big+.question__text.active{\n    transform: translateX(25em) rotate(3deg);\n}\n.question__next{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #8165FA;\n    border-radius: 100%;\n    position: absolute;\n    border: none;\n    width: 2.725em;\n    height: 2.725em;\n    padding: 0;\n    top: 18.25em;\n    right: 0.4em;\n    transition: 0.3s transform;\n    transform: translateX(5em);\n}\n.question__next svg{\n    height: auto;\n    width: 1.1875em;\n}\n.big~.question__next{\n    transform: translateX(0);\n}\n.question__restart{\n    position: absolute;\n    left: 1.65em;\n    bottom: 1.65em;\n    display: flex;\n    align-items: center;    \n    justify-content: center;\n    border: none;\n    background: none;\n    padding: 0;\n    opacity: 0.5;\n}\n.question__restart svg{\n    width: auto;\n    height: 1.125em;\n    clip-path: polygon(0 0, 75% 0, 75% 100%, 0% 100%);\n}\n.question__restart span{\n    font-weight: 500;\n    font-size: 0.875em;\n    color: #fff;\n    letter-spacing: 0.03em;\n    margin-top: 0.05em;\n}\n.question2__title{\n    width: 20.4375em;\n    height: auto;\n    display: block;\n    margin: 1.3em auto 1.6em;\n}\n.question2__text{\n    text-align: center;\n    line-height: 1.2;\n    padding: 0 1em;\n    margin-bottom: -0.3em;\n}\n.question{\n    padding-bottom: 3.5em;\n}\n@media(min-width: 100vh){ \n    .frame:not(.frame--results){\n        font-size: 0.883em;\n    }\n    .question2__title{\n        width: 33.8em;\n        margin: 2.8em auto 1.6em;\n    }\n    .question2__text{\n        font-size: 1.375em;\n    }\n    .main_emo{\n        --koef: 1;\n    }\n    .main_emo--koef{\n        --koef: 4;\n    }\n    .main_emoWrapper{\n        transition: 0.8s margin;\n    }\n    .main_emoWrapper:nth-child(1){\n        margin-left: calc(var(--koef) * 32.7em);\n        top: 12.6em;\n    }\n    .main_emoWrapper:nth-child(2){\n        margin-right:  calc(var(--koef) * 25.5em);\n        top: 7.5em;\n    }\n    .main_emoWrapper:nth-child(3){\n        top: 45.8em; \n        margin-right:  calc(var(--koef) * 37.9em);\n    }\n    .main_emoWrapper:nth-child(4){\n        margin-left:  calc(var(--koef) * 32.6em);\n        top: 60.3em;\n    }\n    .progress{\n        margin-top: 4.3em; \n\n        margin: 4.1em 0 -2.3em;\n    } \n    .progress__item{\n        height: 0.34375em;\n        width: 4.375em;\n    }\n    .video{\n        width: 43em;\n        height: 24.25em;\n        border-radius: 2.8125em;\n    }\n    .video::before{\n        background: linear-gradient(180.61deg, rgba(0, 0, 0, 0.54) 0.53%, rgba(0, 0, 0, 0) 99.47%);\n        height: 5.9375em;\n        border-radius: 2.8125em 2.8125em 0 0;\n    }\n    .video__image{\n        border-radius: 2.8125em;\n    }\n    .video__play{\n        width: 3.75em;\n        margin: -1.875em 0 0 -1.875em;\n    }\n    .started .video__playWrapper2{\n        visibility: visible;\n        pointer-events: all;\n    }\n    .video__playWrapper2 svg{\n        margin: 0.25em;\n        width: 3.75em;\n        transition: 0.3s transform;\n        cursor: pointer;\n    }\n    .started .video__playWrapper2 svg{\n        pointer-events: all;\n    }\n    .video__playWrapper2 svg:hover{\n        transform: scale(1.1);\n    }\n    .started .video__playWrapper2:hover{\n        opacity: 1;\n    }\n    .started .video__playWrapper{\n        pointer-events: none;\n    }\n    .video__playWrapper:hover .video__play{\n        transform: scale(1.1);\n    }\n    .video__muted{\n        left: 2.3em;\n        bottom: 2em;\n        cursor: pointer;\n        z-index: 33;\n        transition: 0.3s transform, 0.3s opacity;\n    } \n    .video__muted:hover{ \n        opacity: 0.7;\n    }\n    .started .video__muted{\n        transform: translateY(5em);\n    }\n    .video:hover .video__muted{\n        transform: translateY(0);\n    }\n    .video__channel{\n        left: 2em;\n        top: 1.9em;\n    }\n    .started .video__channel{\n        transform: translateY(-5em);\n    }\n    .video__channelIcon{\n        width: 1.9375em;\n        margin-right: 0.625em;\n    }\n    .video__channelName{\n        font-size: 1.125em;\n        margin-bottom: 0.1em;\n    }\n    .video__channelSubs{\n        font-size: 0.875em;\n    }\n    .question{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 4.625em;\n        z-index: 2;\n    }\n    .question__content{\n        width: 42.9375em;\n        height: 18.75em;\n        border-radius: 2.8125em;\n        padding: 3.3em 0;\n    }\n    .question__title{\n        font-size: 1.14em;\n        margin-bottom: 4.15em;\n    }\n    .question__title br{\n        display: none;\n    } \n    .question__emo{\n        width: 2.6875em;\n        height: 4.8em;\n        margin: 0 1.5625em;\n        cursor: pointer;\n        transition: 0.3s transform;\n    }\n    .question__emo svg{\n        transition: 0.3s transform;\n    }\n    .question__emos--2.active .question__emo:hover svg,\n    .question__content:not(.answered) .question__emos--1 .question__emo:hover{\n        transform: scale(1.1);\n    }\n    .question__emos--2 .question__emo{\n        height: 4.9em;\n        margin: 0 1.9375em;\n        margin: 0 2.1em;\n    }\n    .question__emos--2{\n        transform: translateY(7em);\n    }\n    .question__content:not(.big) .question__emos--2.active{\n        transform: translateY(-1.7em);\n    }\n    .question__emoText{\n        font-size: 1em;\n    }\n    .question__emo.active{\n        width: 3.125em;\n        height: 5.2em;\n        margin-top: -0.45em;\n    }\n    .question__content.answered .question__title{\n        margin-top: -4.55em;\n    }\n    .question__text{\n        margin: 0;\n        position: absolute;\n        top: 12.9em;\n        left: 50%;\n        margin: 0 0 0 19em;\n        transform: rotate(4.37deg) translateX(50vw);\n        width: 24.375em;\n        height: 28.75em;\n        border-radius: 2.8125em;\n        padding: 0em 3.2em 0;\n    }\n    .question__text.active{\n        transform: rotate(4.37deg);\n    }\n    .big+.question__text.active{\n        transform: rotate(4.37deg) translateX(50vw);\n    }\n    .question__textContent{\n        font-size: 1.125em;\n        line-height: 1.3888;\n    }\n    .question__text1{\n        margin: 0;\n        position: absolute;\n        top: 11.4em;\n        left: 50%;\n        margin: 0 0 0 16.4em;\n        transform: rotate(-5.9deg) translateX(50vw);\n        width: 24.375em;\n        height: 28.75em;\n        border-radius: 2.8125em;\n        padding: 0em 3.2em 0;\n    }\n    .big~.question__text1 {\n        transform: rotate(-5.9deg);\n    }\n    .question__next{\n        right: inherit;\n        left: 50%;\n        top: 24.55em;\n        margin-left: 40.2em;\n        width: 4.3125em;\n        height: 4.3125em;\n        background: #fff;\n        transform: translateX(50vw);\n        transition: 0.3s background, 0.3s transform;\n    }\n    .question__next:hover{\n        background: #9290FF;\n    }\n    .question__next svg{\n        width: 2.0625em;\n    }\n    .question__next path{\n        transition: 0.3s fill;\n        fill: #9290FF;\n    }\n    .question__next:hover path{\n        fill: #fff;\n    }\n    .big~.question__next {\n        transform: translateX(0);\n    }\n    .question__bigText{\n        font-size: 1em;\n    }\n    .question__bigSvg{\n        margin-bottom: 2em;\n    }\n    .question__bigSvg svg{\n        width: 11.68em;\n    }\n    .question__restart{\n        left: 5.7em;\n        bottom: 2.5em;\n    }\n    .question__restart:hover{\n        opacity: 1;\n    }\n    .question__restart svg{\n        clip-path: inherit;\n        height: 1.5em;\n        margin-right: 0.8em;\n    }\n    .question__restart span{\n        font-size: 1.125em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
